var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#F0F0F0"},attrs:{"id":"home"}},[_c('SliderView'),_c('HeaderView'),_c('TagsView'),_c('ContentView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }